const PLP_CATEGORY_SLUGS = [
  'offer',
  'offers',
  'bundle-products',
  'saudi-made',
];

const CONTENT_PAGES = [
  '/about-us',
  '/faqs',
  '/contact-us',
  '/branches',
  '/terms-and-conditions',
  '/privacy-policy',
  '/return-policy',
];

const OTHER_PAGES = ['/prescription'];

const LOGIN_PAGES = ['/login', '/register', '/forgot-password', '/saleslogin'];

export const getPageType = (pathname) => {
  const path = (pathname || '/').split('?')[0].replace(/\/+$/, '') || '/';
  const segments = path.split('/').filter(Boolean);

  switch (true) {
    case path === '/':
      return 'HP';
    case path === '/search':
      return 'Search';
    case path === '/cart':
      return 'Cart';
    case path.startsWith('/checkout'):
      return 'Checkout';
    case path === '/success':
      return 'Confirmation';
    case path === '/favourite' || path === '/user/favourite':
      return 'Wishlist';
    case path === '/categories' || path === '/brands':
      return 'Directory';
    case LOGIN_PAGES.includes(path):
      return 'Login';
    case path.startsWith('/user') || path.startsWith('/track-order'):
      return 'Account';
    case path.startsWith('/cp/'):
      return 'Campaign';
    case path.startsWith('/b/'):
      return 'PLP';
    case path.startsWith('/c/'):
      return segments.length > 2 || PLP_CATEGORY_SLUGS.includes(segments[1])
        ? 'PLP'
        : 'Category';
    case path.startsWith('/cms/') ||
      path.startsWith('/p/') ||
      CONTENT_PAGES.includes(path):
      return 'Content';
    case OTHER_PAGES.includes(path):
      return 'Others';
    case segments.length === 1:
      return 'PDP';
    default:
      return 'Others';
  }
};
